// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// require("@rails/ujs").start()
// require("turbolinks").start()
// require("@rails/activestorage").start()
// require("channels")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import Vue from 'vue'

// Eagerly bundled so that project-wide table overrides in tables.css load AFTER
// vue-good-table's defaults and win the cascade. When this CSS lived in
// lazy-loaded route chunks, its rules were injected AFTER application.css at
// runtime and silently overrode our overrides (e.g. vertical-align: top).
import 'vue-good-table/dist/vue-good-table.css'

import 'sentry'

import router from 'router'

// Global page styles the public views share (see the file's header). Imported
// here, before 'app', so they sit ahead of the Tailwind utilities in the
// cascade exactly as they did when the views were part of this bundle.
import 'styles/public-pages.css'
import store from 'store'
import config from 'config'

import 'filters'

import ActionCableVue from 'actioncable-vue'
Vue.use(ActionCableVue, {
  // debug: true,
  // debugLevel: 'error',
  connectionUrl: config.websocket_url,
  connectImmediately: true
})

import PosthogPlugin from 'plugins/posthog'
Vue.use(PosthogPlugin)

// Starts PostHog and the Tag Manager container only where consent allows it
// (the server made the same call when it rendered the page).
import { applyConsent } from 'utils/consent'
applyConsent()

// Highcharts is heavy (~150KB) and only needed on pages that render <chart>.
// Register globally as an async component so the chunk loads on first chart render.
Vue.component('Chart', () => import(/* webpackChunkName: "highcharts" */ 'plugins/highcharts'))

// Activity indicator
import VueActivityIndicator from 'vue-activity-indicator'
Vue.use(VueActivityIndicator)

import LastModal from 'vue-last-modal'
Vue.use(LastModal)

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

// Metatags
import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import VueMobileDetection from 'vue-mobile-detection'
Vue.use(VueMobileDetection)

// Progress Bar
import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
  color: '#ffab98',
  failedColor: '#cb4848',
  thickness: '1px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 600
  },
  autoRevert: true,
  inverse: false
})

// Global components
import globalComponents from 'components/global'

Object.entries(globalComponents).forEach(([name, component]) => {
  Vue.component(name, component)
})

import App from 'app'
import ensurePaddle from 'utils/paddle'

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    created: () => store.dispatch('init'),
    render: (h) => h(App),
    router,
    store
  }).$mount()

  document.body.appendChild(app.$el)

  // Paddle.js on every page: Paddle sends customers back to our pages and
  // expects it there. It used to be a blocking script tag at the end of the
  // body, which held the app back until it had downloaded; loading it here,
  // once the app is up, keeps it off the first paint. A failure here is not
  // final: the checkout buttons call ensurePaddle() again and report it.
  ensurePaddle().catch(() => {})
})
